export const priceOptions = [
  '100',
  '1000',
  '2000',
  '5000',
  '10000',
  '20000',
  '100000',
];
export const AreaOptions = [
  '0 ',
  '50 ',
  '100 ',
  '150 ',
  '200 ',
  '250 ',
  '300 ',
   '350 ',
  '400 ',
  '450 ',
  '500 ',
];
export const FloorOptions = [
  '1 ',
  '2 ',
  '3 ',
  '4 ',
  '5 ',
  '6 ',
  '7 ',
   '8 ',
  '9 ',
  '10 ',
  '11 ',
];